import React, { useState } from "react";

import HeaderModes from "../../Layouts/Navbar/HeaderModes";
import Navbar from "../../Layouts/Navbar/Navbar";
import BuilderTabs from "../../Layouts/BuilderTabs";
import BuilderModal from "../../Layouts/Modal/BuilderModal";
import BasicFormSettings from "./components/BasicFormSettings";
import AppUserForm from "./components/AppUserForm";
import AppUserSettings from "./components/AppUserSettings";
import { useAppUserContext } from "../../context/AppUserContext";
import useDirtyChecker from "../../hooks/useDirtyChecker";
import axiosInstance, { handleApiError } from "../../services/axiosService";
import { toastSuccess } from "../../utils/toastUtils";
import GenericActionBar from "../../Layouts/GenericActionBar/GenericActionBar";

const initialModalState = {
  isOpen: false,
  data: null,
  name: ""
};

const AppUserEditor = () => {
  const { appUserData, setAppUserData, createFormFieldArray } = useAppUserContext();

  const [isSaving, setIsSaving] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(initialModalState);

  const { isDirty, markClean } = useDirtyChecker({
    ...appUserData,
    fields: createFormFieldArray()
  });

  const handleCloseModal = () => {
    setIsModalOpen(initialModalState);
  };

  const handleOpenModal = (name, data) => {
    setIsModalOpen({ isOpen: true, data, name });
  };

  const handleChangeSetting = (newData) => {
    setAppUserData({
      ...appUserData,
      ...newData
    });
  };

  const handleSaveAppUser = async () => {
    try {
      setIsSaving(true);
      const config = {
        ...appUserData,
        fields: createFormFieldArray()
      };
      const { message } = await axiosInstance.put(`/userConfig`, config);
      toastSuccess(message);
      markClean();
      setIsSaving(false);
    } catch (error) {
      handleApiError(error);
    }
  };

  const tabData = [
    {
      label: "Form",
      content: <AppUserForm />
    },
    {
      label: "Settings",
      content: <AppUserSettings />
    }
  ];

  return (
    <>
      <div className="d_flex">
        <HeaderModes />
        <GenericActionBar
          path={
            <div>
              <em>App User</em>
            </div>
          }
          actions={[
            {
              key: "settings",
              icon: "settings",
              title: "Settings",
              onClick: () => handleOpenModal("Form Settings")
            },
            {
              key: "save",
              icon: "save",
              title: isSaving ? "Saving..." : "Save",
              onClick: isSaving ? undefined : handleSaveAppUser
            }
          ]}
          options={{
            save: {
              className: `${isDirty ? "save_glowing" : ""} ${isSaving ? "disabled" : ""}`.trim()
            }
          }}
        />
      </div>
      <div className="d_flex">
        <Navbar />

        <div className="w_100">
          <BuilderTabs tabs={tabData} tabsClass={"activity_tab"} containerClass="page-action-bar-top align-start" />
        </div>
        <BuilderModal isOpen={isModalOpen.isOpen} onClose={handleCloseModal} modalName={isModalOpen.name}>
          <BasicFormSettings data={appUserData} onChange={handleChangeSetting} />
        </BuilderModal>
      </div>
    </>
  );
};

export default AppUserEditor;
